var map = {
	"./automotive-dark.webp": "18b0",
	"./cpos-dark.webp": "f76d",
	"./emsps-dark.webp": "a174",
	"./ev-drivers-dark.webp": "f0fd",
	"./government-research-dark.webp": "2379"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c1c";